import AuthService from "service/Auth";
import TokenService from "service/Token";

export const getUser = () => {
  const isAuthenticated = !!TokenService.getIsAuthenticated();

  return isAuthenticated ? AuthService.getDataAuth() : "";
};
